<template>
  <div class="ppt-page">
    <img
      v-if="imageUrl"
      :src="imageUrl"
      alt="公司PPT"
      class="ppt-image"
    />
    <div v-else class="no-content">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <circle cx="8.5" cy="8.5" r="1.5"></circle>
        <polyline points="21 15 16 10 5 21"></polyline>
      </svg>
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import { fetchScreenData } from '../utils/api.js'

export default {
  name: 'CompanyPptPage',
  data() {
    return {
      imageUrl: ''
    }
  },
  mounted() {
    this.loadPptImage()
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadPptImage()
      }
    }
  },
  methods: {
    async loadPptImage() {
      try {
        const data = await fetchScreenData()
        this.imageUrl = data || ''
      } catch (error) {
        console.error('获取PPT图片失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.ppt-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a1628;
  overflow: hidden;
}

.ppt-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.no-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #718096;
}

.no-content svg {
  width: 80px;
  height: 80px;
}

.no-content p {
  font-size: 18px;
  margin: 0;
}
</style>
